import { Error } from '@clearkit/icons';

import { MeterIcon, MeterIconProps } from './MeterIcon';

type CompleteCircleProps = MeterIconProps;

export const MeterErrorCircle = ({ ...rest }: CompleteCircleProps) => (
  <MeterIcon {...rest} background="fill-gradient-br-red">
    <Error />
  </MeterIcon>
);
